import { LongButtonSuccess } from 'rootstrap/components/button/styles';
import styled from 'styled-components';

export const SubmitPaymentMethodLongButtonSuccess = styled(LongButtonSuccess)`
  width: 142px;
  float: right;
`;
